import React from "react";

import { Checkbox, Radio, Space, DatePicker, Col, Row, Form, Card } from "antd";

import PageHeading from "../../../components/common/PageHeading";
import FormAction from "../../../components/common/FormAction";

import "./ManagementFeeSettings.css";
import RightBar from "../../../components/common/RightBar";
import Footer from "../../../components/common/Footer";

const FeeSettingsRightBar = [];

const onChange = (date, dateString) => {
  console.log(date, dateString);
};

function ManagementFeeSettings() {
  return (
   <>
    <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Management Fee Settings" />
          <Form 
          layout="vertical"
          colon={false}
          className="management-fee-settings"
          >
          <Row>
            <Col className="feedback-container" span={24}>
              <p className="new-text plain-text">
                <span>NEW</span> Automated Management Fees
              </p>
              <p className="plain-text">
                You can now set up automatic posting of management fees daily,
                weekly, or on specific days of the month.
              </p>
              <button className="feedback-btn">FEEDBACK</button>
            </Col>
          </Row>
          <Row>
            <Col className="fee-automation-settings" span={24}>
                <Card title="Fee Automation Settings">
                  <Form.Item label="Automatically Post Fees">
                    <Checkbox>Enabled</Checkbox>
                  </Form.Item>
                  <Form.Item label="Automatically post management and additional fee bills">
                    <Space direction="vertical">
                      <Radio>On a daily basis</Radio>
                      <Radio>On a weekly basis</Radio>
                      <Radio>On specific days of the month</Radio>
                    </Space>
                  </Form.Item>
                </Card>
            </Col>
          </Row>
          <Row>
            <Col className="fee-posting-schedule" span={24}>
              <Card title="Monthly Fee Posting Schedule">
                <Form.Item label="Post on the">
                  <DatePicker onChange={onChange} />
                </Form.Item>
                <button className="button-link">Add another posting date</button>
              </Card>
            </Col>
          </Row>
          <FormAction />
          </Form>
          <Footer />
        </div>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={FeeSettingsRightBar} />
    </div>
   </>
  );
}

export default ManagementFeeSettings;
